export const FB_PIXEL_ID = '1545009850674181'

let initialized = false

export async function initFacebookPixel() {
  if (initialized || typeof window === 'undefined') return
  const ReactPixel = (await import('react-facebook-pixel')).default
  ReactPixel.init(FB_PIXEL_ID)
  ReactPixel.pageView()
  initialized = true
}

export async function trackFbEvent(
  event: string,
  data?: Record<string, unknown>,
) {
  if (typeof window === 'undefined') return
  const ReactPixel = (await import('react-facebook-pixel')).default
  ReactPixel.track(event, data)
}
